import { useEffect } from 'react';
import { loadCategoryOptions } from '~/features/vault/profile/api';
import { JobListing } from '~/types/hlx/jobListing';
import { MsaasJobListing } from '~/types/hlx/msaasJobListing';

export const useSetProviderCategory = (
  listing: MsaasJobListing | JobListing | undefined,
  setValue: (providerCategory: { value: number; label: string }) => void
) => {
  useEffect(() => {
    const setProviderCategory = async () => {
      const options = await loadCategoryOptions();
      if (!listing) return;
      const providerCategory = options.find(
        (option) => option.value === listing.providerCategoryId
      );
      if (!providerCategory) return;
      setValue(providerCategory);
    };
    setProviderCategory();
  }, [listing]);
};
